module.exports = __webpack_public_path__ + "img/Mission23.fbc1b34b.png";